import { useMutation } from '@tanstack/react-query';

async function saveLockAndUnlock({
  matchDateId,
  isLocked,
}: {
  matchDateId: string;
  isLocked: boolean;
}) {
  try {
    const response = await fetch(`/api/v1/leagues/gameDay/header/saveLockOptInAndOut`, {
      method: 'POST',
      body: JSON.stringify({
        MatchDateID: matchDateId,
        IsLocked: isLocked,
      }),
    });
    const responseData = await response.json();
    return responseData.data;
  } catch {
    /* empty */
  }
}

async function startMatches({ matchDateId }: { matchDateId: string }) {
  try {
    const response = await fetch(`/api/v1/leagues/gameDay/header/saveStartMatches`, {
      method: 'POST',
      body: JSON.stringify({
        MatchDateID: matchDateId,
      }),
    });
    const responseData = await response.json();
    return responseData.data;
  } catch {
    /* empty */
  }
}

async function stopMatches({ matchDateId }: { matchDateId: string }) {
  try {
    const response = await fetch(`/api/v1/leagues/gameDay/header/saveStopMatches`, {
      method: 'POST',
      body: JSON.stringify({
        MatchDateID: matchDateId,
      }),
    });
    const responseData = await response.json();
    return responseData.data;
  } catch {
    /* empty */
  }
}

async function startOverGameDay({ matchDateId }: { matchDateId: string }) {
  try {
    const response = await fetch(`/api/v1/leagues/gameDay/header/startOverGameDay`, {
      method: 'POST',
      body: JSON.stringify({
        MatchDateID: matchDateId,
      }),
    });
    const responseData = await response.json();
    return responseData.data;
  } catch {
    /* empty */
  }
}

async function rollBackToGameDay({
  matchDateId,
  rollbackZeroScores,
}: {
  matchDateId: string;
  rollbackZeroScores: boolean;
}) {
  try {
    const response = await fetch(`/api/v1/leagues/gameDay/header/rollBackToGameDay`, {
      method: 'POST',
      body: JSON.stringify({
        MatchDateID: matchDateId,
        AndStartOver: rollbackZeroScores,
      }),
    });
    const responseData = await response.json();
    return responseData.data;
  } catch {
    /* empty */
  }
}

async function completeGameDay({ matchDateId }: { matchDateId: string }) {
  try {
    const response = await fetch(`/api/v1/leagues/gameDay/header/completeGameDay`, {
      method: 'POST',
      body: JSON.stringify({
        MatchDateID: matchDateId,
      }),
    });
    const responseData = await response.json();
    return responseData.data;
  } catch {
    /* empty */
  }
}

async function saveRatingSequenceAndMove({
  matchDateId,
  sequenceNumber,
  fullName,
}: {
  matchDateId: string;
  sequenceNumber: number;
  fullName: string;
}) {
  try {
    const response = await fetch(`/api/v1/leagues/gameDay/header/saveRatingSequenceAndMove`, {
      method: 'POST',
      body: JSON.stringify({
        matchDateId: matchDateId,
        sequenceNumber: sequenceNumber,
        fullName: fullName,
      }),
    });
    const responseData = await response.json();
    return responseData.data;
  } catch {
    /* empty */
  }
}

async function editLastRound({
  matchDateId,
  sequenceNumber,
}: {
  matchDateId: string;
  sequenceNumber: number;
}) {
  try {
    const response = await fetch(`/api/v1/leagues/gameDay/header/editLastRound`, {
      method: 'POST',
      body: JSON.stringify({
        MatchDateID: matchDateId,
        SequenceNumber: sequenceNumber,
      }),
    });
    const responseData = await response.json();
    return responseData.data;
  } catch {
    /* empty */
  }
}

// For Up Down league, 1) first - save sequence 1 and generate sequence 2 2) use this to complete game day
async function saveSequenceRoundAndGenerateNextOne({
  matchDateId,
  sequenceNumber,
}: {
  matchDateId: string;
  sequenceNumber: number;
}) {
  try {
    const response = await fetch(
      `/api/v1/leagues/gameDay/header/saveSequenceRoundAndGenerateNextOne`,
      {
        method: 'POST',
        body: JSON.stringify({
          matchDateId: matchDateId,
          sequenceNumber: sequenceNumber,
        }),
      }
    );
    const responseData = await response.json();
    return responseData.data;
  } catch {
    /* empty */
  }
}

export const useLockAndUnlock = () => useMutation(saveLockAndUnlock);
export const useStartMatches = () => useMutation(startMatches);
export const useStopMatches = () => useMutation(stopMatches);
export const useStartOverGameDay = () => useMutation(startOverGameDay);
export const useRollBackToGameDay = () => useMutation(rollBackToGameDay);
export const useCompleteGameDay = () => useMutation(completeGameDay);
export const useSaveRatingSequenceAndMove = () => useMutation(saveRatingSequenceAndMove);
export const useEditLastRound = () => useMutation(editLastRound);
export const useSaveSequenceRoundAndGenerateNextOne = () =>
  useMutation(saveSequenceRoundAndGenerateNextOne);
